import React from 'react';
import { useTranslation } from 'react-i18next';

const ClientGDPR = ({ handleExportData, handleDeleteAccount }) => {
    const { t } = useTranslation();

    return (
        <div className="mt-8 bg-bg-card border border-gold/20 shadow-lg rounded-lg p-6 max-w-2xl mx-auto space-y-8 backdrop-blur-sm">
            <div className="pt-2">
                <h4 className="text-lg font-medium mb-2 text-text">{t('gdprDataExport') || "GDPR Data Export"}</h4>
                <p className="text-sm text-text-muted mb-4">
                    {t('gdprExportDescription') || "Download a copy of all your agency data and tours in JSON format."}
                </p>
                <button
                    type="button"
                    onClick={handleExportData}
                    className="bg-bg-soft text-gold border border-gold/20 px-6 py-2 rounded-lg hover:bg-gold/10 transition-colors flex items-center gap-2"
                >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                    </svg>
                    {t('exportMyData') || "Export My Data"}
                </button>
            </div>

            <div className="pt-6 border-t border-gold/10">
                <h4 className="text-lg font-medium mb-2 text-danger-400">{t('dangerZone') || "Danger Zone"}</h4>
                <p className="text-sm text-text-muted mb-4">
                    {t('deleteAccountDescription') || "Permanently delete your account and all associated data. This action cannot be undone."}
                </p>
                <button
                    type="button"
                    onClick={handleDeleteAccount}
                    className="bg-danger-900/10 text-danger-400 border border-danger-500/30 px-6 py-2 rounded-lg hover:bg-danger-900/30 transition-colors flex items-center gap-2"
                >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                    </svg>
                    {t('deleteAccount') || "Delete Account"}
                </button>
            </div>
        </div>
    );
};

export default ClientGDPR;
